import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Instagram, ExternalLink } from "lucide-react";

export const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [handle, setHandle] = useState("");

  useEffect(() => {
    api.get("/instagram/posts").then((r) => setPosts(r.data)).catch(() => {});
    api.get("/config/fees").then((r) => setHandle((r.data?.instagram || "").replace(/^@/, ""))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="py-20 border-t border-sky-500/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 gap-4">
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-sky-400 mb-3 flex items-center gap-2">
              <Instagram className="w-4 h-4" /> Feed do Instagram
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold">Nossos trabalhos ao vivo</h2>
          </div>
          {handle && (
            <a
              href={`https://instagram.com/${handle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] text-white font-semibold hover:brightness-110 transition-all w-fit"
              data-testid="feed-instagram-cta"
            >
              @{handle} <ExternalLink className="w-4 h-4" />
            </a>
          )}
        </div>
        <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" data-testid="instagram-feed-grid">
          {posts.map((p) => {
            const Content = (
              <>
                <div className="relative aspect-square overflow-hidden">
                  <img src={p.image_url} alt={p.caption || "Post"} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                    <Instagram className="w-5 h-5 text-white" />
                  </div>
                </div>
                {p.caption && <div className="p-3 text-xs text-slate-300 line-clamp-2">{p.caption}</div>}
              </>
            );
            return p.post_url ? (
              <a key={p.post_id} href={p.post_url} target="_blank" rel="noopener noreferrer" className="group block bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-pink-500/50 transition-all" data-testid={`insta-post-${p.post_id}`}>
                {Content}
              </a>
            ) : (
              <div key={p.post_id} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden" data-testid={`insta-post-${p.post_id}`}>
                {Content}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
